import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { PreLoginParent, PreLoginContent, PreLoginBody, PreLoginFooter, PreLoginTitle, PreLoginDescription, PreLoginTitleAndDescription, } from "./PreLoginWelcomePageBaseView.styles";
import { addDisplayName } from "../Infra/display-name";
export const PreLoginWelcomeUserBaseView = observer((props) => {
    return (_jsx(PreLoginParent, { children: _jsxs(PreLoginContent, { children: [_jsxs(PreLoginTitleAndDescription, { children: [_jsx(PreLoginTitle, { children: props.title }), _jsx(PreLoginDescription, { children: props.description })] }), _jsx(PreLoginBody, { children: props.children[0] }), _jsx(PreLoginFooter, { children: props.children[1] })] }) }));
});
addDisplayName(PreLoginWelcomeUserBaseView, "PreLoginWelcomeUserBaseView");
